import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=17515ad7&scoped=true"
import script from "./FilePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./FilePreview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FilePreview.vue?vue&type=style&index=0&id=17515ad7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17515ad7",
  null
  
)

export default component.exports